module.exports = __webpack_public_path__ + "img/first.837736c3.svg";